import React, { useState } from "react";
import { connect } from "react-redux";
import { setLanguage } from "../../../store/actions/themeActions";
import { loginEncrypt } from "../AuthenticationLoginV4";
import { useAuth } from "../../../shared/hooks/useAuth";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useQuery } from "../../../shared/hooks/useQuery";
import { Button, Form } from "react-bootstrap";
import IntlMessages from "../../../Utils/IntlMessages";
import Input from "../../../components/forms/Input";

const ReactSwal = withReactContent(
  Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-warning btn-lg",
      cancelButton: "btn btn-default btn-lg",
      actions: "text-center",
    },
  })
);

const AuthenticationAdmin = (props) => {
  const { login } = useAuth();
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [showAlert, setShowAlert] = useState(false);
  let [query, search] = useQuery();

  const onValueChange = (field, e) => {
    let textValue = e.target.value;

    if (field === "email") {
      textValue = textValue.replace(/[^A-Za-z0-9_]/gi, "");
      setUsername(textValue);
    } else {
      setPassword(textValue);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      signin();
    }
  };

  const validateLogin = () => {
    if (!username || !password) {
      setShowAlert(true);
      return false;
    }
    return true;
  };

  const signin = async () => {
    if (!validateLogin()) {
      ReactSwal.fire({
        title: "ไม่สามารถเข้าสู่ระบบได้",
        // text: 'Please contact administrator.',
        text: "กรุณาระบุรหัสผู้ใช้งานและรหัสผ่าน",

        type: "warning",
        // footer: (<a href="#d" onClick={this.prevent}>Why do I have this issue?</a>)
      });

      console.log("ERROR_AUTHEN");

      return;
    }

    const redirectUrl = query.get("intent");

    const uname =
      process.env.REACT_APP_ENCRYPT === "Y" ? loginEncrypt(username) : username;
    const pword =
      process.env.REACT_APP_ENCRYPT === "Y" ? loginEncrypt(password) : password;

    if (redirectUrl) {
      await login(uname, pword, redirectUrl);
    } else {
      await login(uname, pword);
    }
  };

  console.log("AuthenticationAdmin props : ", props)
  return (
    <div
      style={{
        display: "flex", justifyContent: "center", alignItems: "center",
      }}
      className="authentication-wrapper authentication-3"
    >
      <div>
        {/* Logo */}
        <div
          className=""
          style={{ marginBottom: 30, textAlign: "center" }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`}
            alt="Brand"
            className="login-logo"
          />
        </div>
        {/* / Logo */}
        <h3
          style={{
            fontWeight: "bold",
            color: "#006C68",
            textAlign: "center",
          }}
        >
          {<IntlMessages id="login.title" />}
        </h3>
        <h5
          style={{
            color: "#007AFF",
            textAlign: "center",
          }}
        >
          {<IntlMessages id="login.admin_desc" />}
        </h5>
        <form className="">
          <Form.Group>
            <Form.Label>
              {" "}
              {<IntlMessages id="login.username" />}{" "}
            </Form.Label>
            <Input
              onKeyPress={handleKeyPress}
              value={username}
              onChange={onValueChange}
              field="email"
              maxLength={24}
              placeholder={
                props.setting.messages["login.username"]
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="d-flex justify-content-between align-items-end">
              <div> {<IntlMessages id="login.password" />} </div>
            </Form.Label>
            <Input
              onKeyPress={handleKeyPress}
              type="password"
              value={password}
              onChange={onValueChange}
              field="password"
              maxLength={16}
              placeholder={
                props.setting.messages["LOGIN__PLACEHOLDER_PWD"]
              }
            />
          </Form.Group>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <Button
              variant="outline-success"
              block
              style={{ marginTop: 20 }}
              onClick={() => signin()}
            >
              {<IntlMessages id="LOGIN__LOGIN" />}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
export default connect(
  (store) => ({
    setting: store.theme,
  }),
  {
    setLanguage,
  }
)(AuthenticationAdmin);